export default {
  zh: {
    createdOn: '报告生成于',
    filterBy: '筛选逻辑'
  },
  en: {
    createdOn: 'Report Created On',
    filterBy: 'Filtered By'
  }
};



// WEBPACK FOOTER //
// ./src/views/RealTimeReport/i18n.js